import { render, staticRenderFns } from "./ScoopMoreInfo.vue?vue&type=template&id=5020481c&scoped=true&"
import script from "./ScoopMoreInfo.vue?vue&type=script&lang=js&"
export * from "./ScoopMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./ScoopMoreInfo.vue?vue&type=style&index=0&id=5020481c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5020481c",
  null
  
)

export default component.exports